import uniqueId from 'lodash/uniqueId';
import { toRefs, ref, computed, watch } from 'vue';
import tinycolor from 'tinycolor2';
import CloseIcon from '../../icons/component-lib.esm5.js';
import CheckIcon from '../../icons/component-lib.esm14.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm3.js';
import { colors } from '../../styles/component-lib.esm2.js';

//
const ToggleProps = {
  color: {
    type: String,
    default: 'primary'
  },
  value: Boolean,
  disabled: Boolean,
  name: String,
  toggleClass: String,
  size: {
    type: String,
    default: '1.5rem'
  },
  label: String,
  id: String
};
var script = {
  components: {
    CloseIcon,
    CheckIcon
  },
  props: ToggleProps,
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value,
      color,
      size,
      disabled,
      id
    } = toRefs(props);
    const theme = useTheme();
    const checked = ref(false);
    const inputId = computed(() => {
      return id.value || uniqueId('toggle');
    });
    const styles = computed(() => {
      const themeColor = getThemeColor(color.value, theme.value);
      return {
        '--c-bg-active-color': themeColor,
        '--c-icon-active-color': tinycolor(themeColor).isDark() ? colors.white : colors.black,
        '--c-size': size.value
      };
    });
    const classes = computed(() => {
      return {
        'v-toggle--disabled': disabled.value
      };
    });
    watch(value, val => {
      checked.value = val;
    }, {
      immediate: true
    });
    watch(checked, val => {
      emit('input', val);
    });
    return {
      inputId,
      checked,
      classes,
      styles
    };
  }
};
export { ToggleProps, script as default };